const es = {
  // Nav
  nav: {
    home: 'Inicio',
    menu: 'Carta',
    order: 'Pedir',
    gallery: 'Galeria',
    reviews: 'Opiniones',
    reservation: 'Reserva',
    reserve: 'Reservar mesa',
  },

  // Home page
  home: {
    sectionCuisine: 'Nuestra cocina',
    sectionAtmosphere: 'Ambiente',
    sectionFormules: 'Nuestros menus',
    sectionActus: 'Novedades',
    sectionSocial: 'Siguenos',
    sectionExceptions: 'Horarios excepcionales',
    formulesSubtitle: 'Precios que enamoran',
    actusSubtitle: 'Que hay de nuevo?',
    seeGallery: 'Ver la galeria de fotos',
    seeFullMenu: 'Descubrir toda la carta',
    googleRating: '4,1/5 en Google',
    googleRatingValue: '4,1',
    googleReviewsCount: '150 reseñas',
    formulesFrom: 'Menús desde 15 €',
    closed: 'Cerrado',
    burgersCount: 'hamburguesas a elegir',
    callUs: 'Llamarnos',
    directions: 'Como llegar',

    defaultHeroTitle: 'Tu restaurante de barrio en Burdeos',
    defaultHeroSubtitle: 'Cocina sencilla y generosa, terraza sombreada, ambiente acogedor.',
    defaultAboutTitle: 'Sencillo, fresco y generoso',
    defaultAboutText: 'En Cote Terrasse, preparamos una cocina sincera con productos frescos y de temporada.',
    defaultAtmosphereTitle: 'Una terraza con jardin',
    defaultAtmosphereText: 'Disfruta de nuestro comedor con jardin, un autentico remanso de paz en pleno Burdeos.',
    defaultCtaTitle: 'Te apetece venir?',
    defaultCtaText: 'Reserva tu mesa en unos clics o ven a vernos directamente.',
    defaultBtnReserve: 'Reservar mesa',
    defaultBtnMenu: 'Ver la carta',
    defaultBtnCall: 'Llamarnos',
    defaultBtnDirections: 'Como llegar',
  },

  // Reservation
  reservation: {
    sectionLabel: 'Reserva y contacto',
    titleOnline: 'Reserva tu mesa',
    titlePhone: 'Reserva por telefono',
    phoneOnly: 'Reserva solo por telefono',
    phoneDesc: 'Para reservar mesa, llamanos directamente. Nuestro equipo estara encantado de recibirte.',
    callNow: 'Llamar ahora',
    noPhone: 'Numero de telefono no indicado. Contacta con el administrador.',
    formTitle: 'Solicitud de reserva',
    name: 'Nombre',
    phone: 'Telefono',
    email: 'Email',
    date: 'Fecha',
    time: 'Hora',
    guests: 'Comensales',
    guestSingular: 'persona',
    guestPlural: 'personas',
    message: 'Mensaje (opcional)',
    messagePlaceholder: 'Alergias, peticiones especiales...',
    choose: 'Elegir',
    namePlaceholder: 'Tu nombre',
    phonePlaceholder: '+33 6 ...',
    emailPlaceholder: 'tu@email.com',
    submit: 'Enviar solicitud',
    sending: 'Enviando...',
    success: 'Solicitud de reserva enviada! Nos pondremos en contacto contigo pronto.',
    errorDate: 'Por favor, selecciona una fecha',
    errorTime: 'Por favor, selecciona una hora',
    errorGeneric: 'Error al enviar. Por favor, intentalo de nuevo.',
    infoTitle: 'Informacion practica',
    openingHours: 'Horario de apertura',
    closed: 'Cerrado',
  },

  // Gallery
  gallery: {
    sectionLabel: 'Galeria',
    title: 'En imagenes',
    description: 'Descubre nuestra terraza, nuestro comedor con jardin y nuestros platos en fotos.',
    all: 'Todas',
    plats: 'Platos',
    terrasse: 'Terraza',
    salle: 'Comedor',
    ambiance: 'Ambiente',
    empty: 'No hay fotos en esta categoria.',
    lightboxTitle: 'Foto de la galeria',
  },

  // Menu
  menu: {
    sectionLabel: 'Nuestra carta',
    title: 'La Carta',
    description: 'Descubre nuestras hamburguesas caseras, tapas para compartir, y nuestros menus ventajosos. Cocina preparada con productos frescos y de temporada.',
    formules: 'Menus',
    supplements: 'Suplementos:',
    from: 'desde',
    sides: 'Guarniciones',
    sidesIncluded: 'Incluido en el precio de la hamburguesa:',
    sidesIncludedText: 'Patatas fritas frescas o Ensalada de temporada.',
    sidesSupplements: 'Suplementos:',
    sidesSupplementsText: 'Patatas de boniato +3EUR | Bacon +3EUR | Cheddar +2EUR',
    sidesNote: 'Filete ANGUS 100% Pura Ternera Origen Francia 150g — Patatas Fritas frescas al estilo belga con Grasa de Ternera — Magret de Pato del Suroeste de Francia',
  },

  // Reviews
  reviews: {
    sectionLabel: 'Opiniones de clientes',
    title: 'Lo que opinan',
    description: 'Mayoria de opiniones de 4 y 5 estrellas. Nuestros clientes valoran la calidad de nuestra cocina, precios razonables y ambiente acogedor.',
    outOf: 'Mas de 200 opiniones',
  },

  // Legal
  legal: {
    title: 'Aviso legal',
    editor: 'Editor del sitio',
    hosting: 'Alojamiento',
    ip: 'Propiedad intelectual',
    ipText: 'Todo el contenido de este sitio (textos, imagenes, logotipos, fotos) es propiedad exclusiva de Cote Terrasse, salvo indicacion contraria. Queda prohibida toda reproduccion, incluso parcial, sin autorizacion previa.',
    data: 'Datos personales',
    dataText: 'La informacion recogida a traves del formulario de reserva (nombre, email, telefono) se utiliza unicamente para tramitar su solicitud de reserva. De acuerdo con el RGPD, usted tiene derecho de acceso, rectificacion, limitacion y supresion de sus datos personales.',
    dataTextPhone: 'No recopilamos ningun dato personal directamente en este sitio web para reservas, ya que se realizan exclusivamente por telefono. De acuerdo con el RGPD, usted tiene derecho de acceso, rectificacion, limitacion y supresion de sus datos personales.',
    cookies: 'Cookies',
    cookiesText: 'Este sitio utiliza cookies tecnicas necesarias para su correcto funcionamiento. No se utilizan cookies publicitarias ni de seguimiento.',
    privacy: 'Politica de privacidad',
    privacyText: 'Nos comprometemos a proteger su privacidad. Los datos personales que nos facilite nunca se transmiten a terceros. Se conservan durante un periodo maximo de 12 meses.',
    responsibility: 'Responsabilidad',
    responsibilityText: 'Cote Terrasse se esfuerza por ofrecer informacion lo mas precisa posible. Los precios y horarios mostrados pueden sufrir modificaciones sin previo aviso.',
    publishedBy: 'Director de la publicacion',
    phone: 'Telefono',
    mediation: 'Mediacion de consumo',
    alcohol: 'Licencia de alcohol',
    meatOrigin: 'Origen de las carnes',
  },

  // Cookies banner
  cookies: {
    bannerText: 'Cote Terrasse utiliza cookies para asegurar el correcto funcionamiento de su sitio. Puede elegir aceptar o personalizar el uso de cookies de medicion de audiencia.',
    accept: 'Aceptar todo',
    decline: 'Rechazar',
    customize: 'Personalizar',
    save: 'Guardar preferencias',
    essentialOnly: 'Solo cookies esenciales',
    title: 'Ajustes de cookies',
    essentialTitle: 'Cookies tecnicas (Obligatorias)',
    essentialDesc: 'Estas cookies son indispensables para el funcionamiento del sitio (sesion de administrador, carrito). No se pueden desactivar.',
    analyticsTitle: 'Cookies analiticas (Opcionales)',
    analyticsDesc: 'Estas cookies nos permiten medir el trafico del sitio y mejorar su experiencia de navegacion.',
  },

  // CGV
  cgv: {
    title: 'Condiciones Generales de Venta (CGV)',
    intro: 'Las presentes Condiciones Generales de Venta regulan los pedidos realizados en el marco del servicio Click & Collect ofrecido por el restaurante Cote Terrasse.',
    article1Title: '1. Objeto',
    article1Text: 'Las CGV se aplican a cualquier pedido de platos realizado por el Cliente en el sitio para ser recogido en el restaurante Cote Terrasse.',
    article2Title: '2. Pedido y Obligacion de pago',
    article2Text: 'Cualquier validacion de pedido en el sitio implica una obligacion de pago por parte del Cliente. El pago se realiza en linea o al recoger el pedido segun las opciones ofrecidas.',
    article3Title: '3. Derecho de desistimiento (Exclusion)',
    article3Text: 'De conformidad con el articulo L. 221-28 12° del Codigo de Consumo frances, los contratos de suministro de servicios de restauracion que deban prestarse en una fecha o periodo especifico no se benefician del derecho de desistimiento. Al ser productos perecederos y preparados bajo pedido, ningun pedido validado puede ser cancelado o reembolsado.',
    article4Title: '4. Recogida de pedidos',
    article4Text: 'El Cliente se compromete a recoger su pedido en el dia y franja horaria elegidos. Debido al caracter perecedero de los productos, ningun pedido no reclamado podra ser reembolsado ni conservado mas alla del dia de recogida.',
    article5Title: '5. Mediacion de consumo',
    article5Text: 'En caso de litigio no resuelto, el Cliente puede ponerse en contacto con el mediador de consumo designado. Sus datos de contacto estan disponibles en la pagina de Aviso Legal del sitio.',
  },

  // Allergènes
  allergens: {
    title: 'Alergenos Regulados',
    subtitle: 'De conformidad con el Reglamento (UE) n° 1169/2011, a continuacion se detalla la lista de los 14 alergenos principales que pueden estar presentes en nuestros platos:',
    notice: 'Nuestro personal queda a su entera disposicion para cualquier detalle sobre la composicion de nuestros platos.',
    names: {
      gluten: 'Gluten',
      crustaceans: 'Crustaceos',
      eggs: 'Huevos',
      fish: 'Pescado',
      peanuts: 'Cacahuetes',
      soybeans: 'Soja',
      milk: 'Leche',
      nuts: 'Frutos de cascara',
      celery: 'Apio',
      mustard: 'Mostaza',
      sesame: 'Granos de sesamo',
      sulphites: 'Sulfitos',
      lupin: 'Altramuces',
      molluscs: 'Moluscos',
    },
    list: {
      gluten: 'Cereales que contengan gluten (trigo, centeno, cebada, avena...)',
      crustaceans: 'Crustaceos y productos a base de crustaceos',
      eggs: 'Huevos y productos a base de huevos',
      fish: 'Pescado y productos a base de pescado',
      peanuts: 'Cacahuetes y productos a base de cacahuetes',
      soybeans: 'Soja y productos a base de soja',
      milk: 'Leche y sus derivados (incluida la lactosa)',
      nuts: 'Frutos de cascara (almendras, avellanas, nueces, pistachos...)',
      celery: 'Apio y productos derivados',
      mustard: 'Mostaza y productos derivados',
      sesame: 'Granos de sesamo y productos derivados',
      sulphites: 'Dioxido de azufre y sulfitos (en concentraciones superiores a 10 mg/kg o 10 mg/l)',
      lupin: 'Altramuces y productos derivados',
      molluscs: 'Moluscos y productos derivados',
    }
  },

  // Footer
  footer: {
    description: 'Restaurante acogedor en Burdeos. Cocina de temporada, hamburguesas caseras y una agradable terraza con jardin.',
    navigation: 'Navegacion',
    contact: 'Contacto',
    ourMenu: 'Nuestra Carta',
    customerReviews: 'Opiniones',
    legalNotice: 'Aviso legal',
    legalAndPrivacy: 'Aviso legal y Politica de privacidad',
    admin: 'Administracion',
    copyright: 'Todos los derechos reservados.',
    defaultAccessTram: 'Acceso: Tranvia A (parada cercana)',
    defaultAccessBus: 'Acceso: Autobus 9 (parada cercana)',
    allergenNotice: 'Precios netos expresados en Euros IVA incluido. De acuerdo con el Decreto N° 2015-447, la informacion sobre los alergenos presentes en nuestros platos esta disponible a peticion o se puede consultar en la pagina de Alergenos.',
  },

  // Maintenance
  maintenance: {
    comingSoon: 'Volvemos pronto',
    defaultMessage: 'Nuestro sitio web esta en proceso de actualizacion. Gracias por su paciencia.',
    openingHours: 'Horario de apertura',
    closed: 'Cerrado',
    copyright: 'Todos los derechos reservados.',
  },

  // Common
  common: {
    closed: 'Cerrado',
    loading: 'Cargando...',
  },
};

export default es;
